import { baseApi as api } from "../baseApi";
export const addTagTypes = ["Order chat"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      listOrderMessages: build.query<
        ListOrderMessagesApiResponse,
        ListOrderMessagesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/vendor/orders/${queryArg.orderId}/messages`,
        }),
        providesTags: ["Order chat"],
      }),
      sendOrderMessage: build.mutation<
        SendOrderMessageApiResponse,
        SendOrderMessageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/vendor/orders/${queryArg.orderId}/messages`,
          method: "POST",
          body: queryArg.sendMessageForm,
        }),
        invalidatesTags: ["Order chat"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as orderChatApi };
export type ListOrderMessagesApiResponse =
  /** status 200 OK */ OrderMessageData[];
export type ListOrderMessagesApiArg = {
  orderId: number;
};
export type SendOrderMessageApiResponse =
  /** status 201 Created */ OrderMessageData;
export type SendOrderMessageApiArg = {
  orderId: number;
  sendMessageForm: SendMessageForm;
};
export type OrderMessageData = {
  contentType?: string;
  createdAt?: string;
  /** File name; null for text */
  fileName?: string;
  fileSize?: number;
  id?: number;
  messageType?: "TEXT" | "FILE";
  sender?: "VENDOR" | "CUSTOMER";
  /** The text; null for a file */
  text?: string;
};
export type SendMessageForm = {
  text?: string;
};
export const {
  useListOrderMessagesQuery,
  useLazyListOrderMessagesQuery,
  useSendOrderMessageMutation,
} = injectedRtkApi;
